var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-section-title",class:{'is-primary': _vm.primary, 'is-secondary': _vm.secondary}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }